import List from "@/components/list";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const AccountTableConfig = [
    {
      label: "图书类型",
      prop: "typeName",
      minWidth: "150"
    },
    {
      label: "分值",
      prop: "ruleValue",
      minWidth: "150",
      render: e => {
        return (
          <input
            type="number"
            min={0}
            key={e.row.ruleKey}
            value={e.row.ruleValue}
            style={"width: 96px; height: 26px; padding: 0 4px;"}
            onInput={function(event) {
              e.row.ruleValue = event.target.value;
            }}
          ></input>
        );
      }
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
